/**
 * Farmer Image Upload Types and API
 *
 * Type definitions and API client for farmer image uploads.
 * Data fetching is handled by React Query hooks in useFarmerImageUploadQueries.ts
 */

import { API } from "common/utils";

export type FarmerImageUpload = {
  guid: string;
  image: string;
  imageName: string;
};

export type ImageUploadPayload = {
  imageName: string;
  image: string;
};

class FarmerImageUploadAPI extends API<FarmerImageUpload> {
  async uploadImage(payload: ImageUploadPayload): Promise<{ guid: string }> {
    const res = await fetch(`${this.baseUrl}farmerImageUpload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt") || ""}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    return (await res.json()) as { guid: string };
  }
}

export const farmerImageUploadApi = new FarmerImageUploadAPI(
  "farmerImageUpload"
);
